(function () {
  'use strict';

  function init() {
    var toc = document.querySelector('[data-blog-toc]');
    if (!toc) return;

    var links = Array.prototype.slice.call(
      toc.querySelectorAll('.article-seo__toc-link')
    );

    toc.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var id = decodeURIComponent(link.hash.slice(1));
      var target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) {
        history.replaceState(null, '', link.hash);
      }
    });

    var toggle = toc.querySelector('[data-blog-toc-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        toc.classList.toggle('is-open', !expanded);
      });

      toc.addEventListener('click', function (event) {
        if (toggle.offsetParent === null) return;
        if (event.target.closest('[data-blog-toc-toggle], nav')) return;
        toggle.click();
      });
    }

    if ('IntersectionObserver' in window && links.length) {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var progress = toc.querySelector('.article-seo__toc-progress');
      var linkById = {};
      var ids = [];
      links.forEach(function (link) {
        var id = decodeURIComponent(link.hash.slice(1));
        linkById[id] = link;
        ids.push(id);
      });

      var visible = {};
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            visible[entry.target.id] = entry.isIntersecting;
          });

          var activeId = null;
          var activeIndex = -1;
          for (var i = 0; i < ids.length; i += 1) {
            if (visible[ids[i]]) {
              activeId = ids[i];
              activeIndex = i;
              break;
            }
          }

          ids.forEach(function (id) {
            linkById[id].classList.toggle('is-active', id === activeId);
          });

          if (progress && activeIndex > -1) {
            var pct = ((activeIndex + 1) / ids.length) * 100;
            if (reduceMotion) progress.style.transition = 'none';
            progress.style.height = pct + '%';
          }
        },
        { rootMargin: '-80px 0px -70% 0px', threshold: 0 }
      );

      ids.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) observer.observe(el);
      });
    }
  }

  function initCarousels() {
    document.querySelectorAll('[data-seo-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-seo-carousel-track]');
      var nav = carousel.querySelector('[data-seo-carousel-nav]');
      var prev = carousel.querySelector('[data-seo-carousel-prev]');
      var next = carousel.querySelector('[data-seo-carousel-next]');
      if (!track || !nav || !prev || !next) return;

      function step() {
        var slide = track.firstElementChild;
        if (!slide) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        nav.hidden = max <= 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function start() {
    init();
    initCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
